(function () {
  if (window.__amzHome) return;
  window.__amzHome = true;

  function initScroller(root) {
    if (root.__amz) return; root.__amz = true;
    var track = root.querySelector('.amz-scroller__track');
    if (!track) return;
    var prev = root.querySelector('[data-dir="-1"]');
    var next = root.querySelector('[data-dir="1"]');
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    [prev, next].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        track.scrollBy({ left: Number(btn.dataset.dir) * track.clientWidth * 0.9, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initHero(root) {
    if (root.__amz) return; root.__amz = true;
    var track = root.querySelector('.amz-hero__track');
    if (!track) return;
    var count = track.children.length;
    var navs = root.querySelectorAll('.amz-hero__nav');
    if (count < 2) { navs.forEach(function (b) { b.hidden = true; }); return; }
    var dots = root.querySelectorAll('.amz-hero__dot');
    var timer;
    var speed = (Number(root.dataset.speed) || 5) * 1000;
    var auto = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { i = (i + count) % count; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function restart() { clearInterval(timer); if (auto) timer = setInterval(function () { go(index() + 1); }, speed); }
    root.querySelector('.amz-hero__nav--prev').addEventListener('click', function () { go(index() - 1); restart(); });
    root.querySelector('.amz-hero__nav--next').addEventListener('click', function () { go(index() + 1); restart(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });
    track.addEventListener('scroll', function () {
      var i = index();
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    restart();
  }

  function initTop(btn) {
    if (btn.__amz) return; btn.__amz = true;
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-amz-scroller]').forEach(initScroller);
    scope.querySelectorAll('[data-amz-hero]').forEach(initHero);
    scope.querySelectorAll('[data-amz-top]').forEach(initTop);
  }
  window.amzInit = init;

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();